import * as React from 'react';
import { AddStroke16 } from '@cian/ui-kit';
import * as styles from './CreateFolderButton.css';
export function CreateFolderButton(_ref) {
  var onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement("button", {
    className: styles['button'],
    onClick: onClick
  }, /*#__PURE__*/React.createElement("span", {
    className: styles['icon']
  }, /*#__PURE__*/React.createElement(AddStroke16, null)), /*#__PURE__*/React.createElement("span", null, "\u041D\u043E\u0432\u0430\u044F \u043F\u043E\u0434\u0431\u043E\u0440\u043A\u0430"));
}